import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { SistemaStatusService } from '../services/sistema-status.service';

export const sistemaStatusGuard = async () => {
  if (environment.skipSistemaStatusCheck) return true;

  const sistemaStatus = inject(SistemaStatusService);
  const router = inject(Router);

  await sistemaStatus.loadStatus();

  if (!sistemaStatus.status().estatus) {
    return router.createUrlTree(['/auth', 'mantenimiento']);
  }

  return true;
};
